import * as React from "react";
import { UitkCard, UitkCardContent, UitkCardTextSegment, UitkCardMedia } from "uitk-react-cards";
import { UitkImage, UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
import { UitkLoader } from "uitk-react-loader";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { formatText } from "bernie-l10n";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
import { MapMarkerCardProps, MapMarkerCardViewProps } from "../typings";
import { MarkerIcon } from "../markers/MapMarkers";

export const MAP_CARD_ID = "dx-map-card";
export const MAP_CARD_IMAGE_ID = "dx-map-card-image";

export const MapMarkerCard = (props: MapMarkerCardProps) => {
  return (
    <Viewport>
      <ViewSmall>
        <MapMarkerCardView
          showCard={props.showCard}
          onClose={props.onClose}
          content={props.content}
          isMobile={true}
        />
      </ViewSmall>
      <ViewLarge>
        <MapMarkerCardView
          showCard={props.showCard}
          onClose={props.onClose}
          content={props.content}
          isMobile={false}
        />
      </ViewLarge>
    </Viewport>
  );
};

@observer
class MapMarkerCardView extends React.Component<MapMarkerCardViewProps> {
  private imageRef: any;

  @observable
  private showLoader: boolean = true;

  @action
  private revealLoader = () => {
    this.showLoader = true;
  };

  constructor(props: MapMarkerCardViewProps) {
    super(props);
    this.imageRef = React.createRef();
  }

  @action
  private hideLoader = () => {
    this.showLoader = false;
  };

  /* istanbul ignore next line */
  public componentDidUpdate() {
    if (this.imageRef.current && this.imageRef.current.complete === false) {
      this.revealLoader();
      this.imageRef.current.addEventListener("load", () => {
        this.hideLoader();
      });
    }
  }

  public render() {
    const cardClasses = this.props.isMobile ? "map-card" : "map-card map-card--desktop";

    return (
      <div
        id={MAP_CARD_ID}
        className={this.props.showCard ? `${cardClasses} map-card--reveal` : cardClasses}
      >
        <UitkCard>
          <UitkCardTextSegment>
            <div className="uitk-grid">
              <div className="uitk-cell all-cell-fill">
                <h2 className="uitk-type-heading-500">{this.props.content.title}</h2>
              </div>
              <div className="uitk-cell all-cell-1-6 uitk-type-right">
                <button
                  title={formatText("destinationDiscoveryMap.button.card.close")}
                  onClick={this.props.onClose}
                >
                  <UitkIcon name="close" />
                </button>
              </div>
            </div>
          </UitkCardTextSegment>
          {this.props.content.photoUrl && (
            <UitkCardMedia>
              <UitkFigure ratio={UitkFigureAspectRatioType.R16_9}>
                {this.showLoader && (
                  <div className="uitk-flex uitk-flex-align-items-center uitk-flex-justify-content-center map-card__loader">
                    <UitkLoader />
                  </div>
                )}
                <UitkImage
                  imgRef={this.imageRef}
                  alt={
                    this.props.content.attribution
                      ? this.props.content.attribution.attributionAltText
                      : this.props.content.photoAlt
                  }
                  src={this.props.content.photoUrl}
                />
                {this.props.content.attribution && this.props.content.attribution.attributionText}
              </UitkFigure>
            </UitkCardMedia>
          )}
          <UitkCardContent>
            {this.props.content.price && (
              <UitkCardTextSegment className="uitk-card-separator-bottom uitk-type-right">
                {this.props.content.type === MarkerIcon.HOTEL && (
                  <p className="uitk-type-600">
                    {formatText("destinationDiscoveryMap.hotel.price", this.props.content.price)}
                  </p>
                )}
                {this.props.content.type === MarkerIcon.ACTIVITY && (
                  <p className="uitk-type-600">
                    {formatText("destinationDiscoveryMap.activity.price", this.props.content.price)}
                  </p>
                )}
              </UitkCardTextSegment>
            )}
            <UitkCardTextSegment className="uitk-flex">
              {this.props.content.description}
              <UitkPrimaryButton
                className="map-card__button--margin"
                text={this.props.content.buttonLabel}
                icon={this.props.content.buttonIcon}
                isFullWidth={true}
                href={this.props.content.link}
              />
            </UitkCardTextSegment>
          </UitkCardContent>
        </UitkCard>
      </div>
    );
  }
}

export default MapMarkerCard;
